/**
 * Reusable fetch wrapper. Central error handling and JSON.
 * Components must use this (or api/phpApi, nodeApi, aiApi) — no direct fetch in components.
 */
export async function apiFetch(url, options = {}) {
  const { method = 'GET', body, headers = {}, ...rest } = options;
  const h = { ...headers };
  if (body) {
    if (body instanceof FormData) {
      rest.body = body;
    } else if (body instanceof URLSearchParams) {
      rest.body = body;
      h['Content-Type'] = 'application/x-www-form-urlencoded';
    } else if (typeof body === 'object') {
      h['Content-Type'] = h['Content-Type'] || 'application/json';
      try {
        rest.body = JSON.stringify(body);
      } catch (e) {
        rest.body = body;
      }
    } else {
      rest.body = body;
    }
  } else {
    h['Content-Type'] = 'application/json';
  }
  const res = await fetch(url, { method, headers: h, ...rest });
  const contentType = res.headers.get('content-type');
  const isJson = contentType && contentType.includes('application/json');
  let data = null;
  if (isJson) {
    try {
      data = await res.json();
    } catch (_) {
      data = null;
    }
  }
  if (!res.ok) {
    const err = new Error(data?.message || data?.error || `HTTP ${res.status}`);
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data !== null ? data : res;
}
